import { MAX_ATTACHMENT_CONTENT_LENGTH } from "@repo/app-types/constants/shared";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { Loader, LoaderStyle } from "@repo/ui/Loader/loader";
import type { FC } from "react";
import { DiffableField } from "../../../components/diffableField.js";

export interface AttachmentEditorContentProps {
  isLoading: boolean;
  isSaving: boolean;
  /** Renders the content non-editable (e.g. a synced, read-only document). */
  isReadOnly?: boolean;
  editedBody: string;
  savedBody: string;
  setEditedBody: (value: string) => void;
  /** The body a pending Ask Alpharun suggestion would save. */
  suggestedBody?: string;
}

export const AttachmentEditorContent: FC<AttachmentEditorContentProps> = (
  props,
) => {
  const {
    isLoading,
    isSaving,
    isReadOnly,
    editedBody,
    savedBody,
    setEditedBody,
    suggestedBody,
  } = props;

  return (
    <div className="flex min-w-0 flex-1 flex-col overflow-hidden bg-white">
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Loader style={LoaderStyle.SPINNER} />
        </div>
      ) : (
        <div className="flex min-h-0 flex-1 flex-col p-6">
          <DiffableField
            label={<Label size={Size.SMALL}>Document content</Label>}
            value={editedBody}
            onChange={setEditedBody}
            originalValue={savedBody}
            suggestedValue={suggestedBody}
            placeholder="Enter content..."
            maxLength={MAX_ATTACHMENT_CONTENT_LENGTH}
            isReadOnly={isSaving || isReadOnly}
            collapseUnchanged
            hasDiffMinimap
            editorClassName="min-h-0 flex-1"
          />
        </div>
      )}
    </div>
  );
};
